<!-- 二维码登录 + 第三方登录 -->
<template>
  <base-popup
    class="base-popup"
    :activeTab="activeTab"
    :showPhoneLogin="showPhoneLogin"
    v-bind="$attrs"
    v-on="$listeners"
    @open="init"
    @changeLogin="changeLogin"
  >
    <div v-if="loginLoading" class="loading">
      <img :src="require('@assets/img/loading.gif')" />
    </div>

    <div v-show="showPhoneLogin === 0" class="login-menu">
      <div class="login-menu__title">{{ $t('lang099') }}</div>
      <!-- 二维码登录 start -->
      <div class="login-menu__before">
        <div>
          <div class="qrcode-box">
            <div class="qrcode-loading">
              <img :src="require('@assets/img/loading.gif')" />
            </div>

            <div ref="qrcodeImage" class="qrcode-image"></div>

            <div v-if="overdueVisible" class="qrcode-overdue">
              <p class="qrcode-overdue__tips">Overdue QR Code</p>

              <button
                class="qrcode-overdue__btn-refresh"
                @click="refreshQrcode"
              >
                {{ $t('lang168') }}
              </button>
            </div>
          </div>

          <div class="scan-tips">
            <div>
              {{ $t('lang100') }}
            </div>
            <div>
              {{ $t('lang101') }}
            </div>
          </div>
        </div>

        <div class="scan-sample"></div>
      </div>

      <!-- 二维码登录 end -->
      <div class="other-login">
        <span class="other-login__or">or</span>

        <div class="other-login__box">
          <button
            class="other-login__box__facebook"
            @click="fbLoginCall"
          ></button>

          <!-- 新谷歌登录 -->
          <div
            id="g_id_onload"
            data-client_id="322067568803-p11qbhovgr87s4n51en6n876b7q57l6k.apps.googleusercontent.com"
            data-context="signin"
            data-ux_mode="popup"
            data-callback="ggLoginCallNew"
            data-auto_prompt="false"
            data-auto_select="false"
            style="display: none;"
          ></div>
          <button
            class="g_id_signin other-login__box__google"
            data-type="icon"
            data-shape="circle"
            data-theme="outline"
            data-text="signin_with"
            data-size="large"
          ></button>

          <!-- <button
            class="other-login__box__phone"
            @click="changePhoneLogin(1)"
          ></button> -->
          <button class="other-login__box__vk" @click="vkLoginCall"></button>
          <!-- <button
            class="other-login__box__twitter"
            @click="twLoginCall"
          ></button> -->
        </div>

        <div class="register-tips">
          {{ $t('lang104') }}
          <a href="javascript:;" @click="changePhoneLogin(2)">
            {{ $t('lang106') }}
          </a>
        </div>

        <policy
          :showAgreeTips="showAgreeTips"
          @hideAgreeTips="showAgreeTips = false"
          @emitAgree="emitAgree"
        />
      </div>
    </div>

    <phone-login
      v-if="showPhoneLogin !== 0"
      ref="phoneLogin"
      :type="showPhoneLogin"
      @back="showPhoneLogin = 0"
      @activeTabChange="activeTabChange"
    />
  </base-popup>
</template>

<script>
import PhoneLogin from '@components/LoginPopup/PhoneLogin';
import getDeviceId from '@components/Player/deviceId';
import BasePopup from './BasePopup';
import Policy from './Policy';

function insertScript(id, scriptUrl) {
  const fjs = document.getElementsByTagName('script')[0];
  if (!document.getElementById(id)) {
    const js = document.createElement('script');
    js.id = id;
    js.src = scriptUrl;
    fjs.parentNode.insertBefore(js, fjs);
  }
}

/* eslint-disable */
export default {
  components: {
    PhoneLogin,
    BasePopup,
    Policy
  },
  data() {
    return {
      // 二维码过期的提示
      overdueVisible: false,
      // 0: 隐藏 1: 登录 2: 注册
      showPhoneLogin: 0,
      // 第三方登录loading
      loginLoading: false,
      // 是否同意隐私政策
      isAgree: true,
      showAgreeTips: false,
      activeTab: 0
    };
  },
  computed: {},
  methods: {
    activeTabChange(activeTab) {
      this.activeTab = activeTab;
    },
    emitAgree(agree) {
      this.isAgree = agree;
    },
    changeLogin() {
      if (this.activeTab === 3) {
        // activeTab === 3 是忘记密码, 切到登录模块
        this.$refs.phoneLogin.changeActiveTab(0);
        return;
      }
      if (this.showPhoneLogin === 0) {
        this.showPhoneLogin = 1;
      } else {
        this.showPhoneLogin = 0;
      }
    },
    init() {
      this.getQrcode();

      window.ggLoginCallNew = this.ggLoginCallNew.bind(this); // 谷歌html绑定使用的是 window 的方法
      insertScript('google-jssdk', 'https://accounts.google.com/gsi/client');
    },
    close() {
      this.$emit('input', false);
    },
    changePhoneLogin(type) {
      // if (!this.isAgree) {
      //   this.showAgreeTips = true;
      //   return;
      // }
      this.showPhoneLogin = type;
    },
    clearQrcode() {
      const qrcodeImageDom = this.$refs.qrcodeImage;
      if (qrcodeImageDom) {
        qrcodeImageDom.innerHTML = '';
      }
    },
    createQrcode(val) {
      const qrcodeImageDom = this.$refs.qrcodeImage;
      if (qrcodeImageDom) {
        let valArr = [];
        let url = '';
        if (val.uid) {
          const { qrCodeNew, uid } = val;
          valArr = uid.split('_');
          url = `http://www.bigo.tv/index_wap.html?dl=bigolive://loginWeb?tempuid=${valArr[0]}&time=${valArr[1]}&newcode=${qrCodeNew}`;
        } else {
          valArr = val.split('_');
          url = `http://www.bigo.tv/index_wap.html?dl=bigolive://loginWeb?tempuid=${valArr[0]}&time=${valArr[1]}`;
        }
        // eslint-disable-next-line
        new window.QRCode(qrcodeImageDom, {
          text: url,
          width: 154,
          height: 154,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: window.QRCode.CorrectLevel.M
        });
      }
    },
    refreshQrcode() {
      this.getQrcode();
      this.overdueVisible = false;
    },
    async getTokenTest(tempuid) {
      const qrcodeImageDom = this.$refs.qrcodeImage;
      const params = { type: 100, id: tempuid };

      const res = await this.$api.comet(params);
      if (res && res.code === 0) {
        const { status } = res.data;
        if (status === 0) {
          console.log('成功登陆！');
          this.$toast('Success');
          window.location.reload();
        } else if (status === 1 && qrcodeImageDom) {
          // 只有弹窗仍打开（qrcodeImageDom存在）的情况下继续轮询，否则终止轮询
          setTimeout(() => {
            this.getTokenTest(tempuid);
          }, 1000);
        } else if (status === 2) {
          console.log('二维码过期！');
          this.overdueVisible = true;
        }
      }
    },
    async getQrcode() {
      this.clearQrcode();
      const deviceId = await getDeviceId();
      const res = await this.$api.qrcode({ deviceId });
      if (res && res.code === 0) {
        const data = res.data;
        this.createQrcode(data);
        this.getTokenTest(data.uid.split('_')[0]);
        this.$log && this.$log.info('qrcode success');
      } else {
        this.$log &&
          this.$log.error('qrcode error', { msg: JSON.stringify(res) });
      }
    },
    async loginFromOtherChannel(uid, token, type, sign = '') {
      const deviceId = await getDeviceId();
      const data = {
        interfaceName: 'loginChannel',
        uid,
        token,
        type,
        sign,
        deviceId
      };
      this.loginLoading = true;
      const res = await this.$api.directLogin(data);
      if (res && res.code === 0) {
        this.$toast('Success');
        this.$log && this.$log.info('directLogin success', { msg: res.code });
        window.location.reload();
      } else {
        this.$toast(`${res.code}: ${res.msg}`);
        this.$log && this.$log.error('directLogin error', { msg: res.code });
      }
      this.loginLoading = false;
    },
    fbLoginCall() {
      if (!this.isAgree) {
        this.showAgreeTips = true;
        return;
      }
      const that = this;
      const id = 'facebook-jssdk';

      window.fbAsyncInit = () => {
        window.FB.init({
          appId: '953097631439235',
          cookie: true, // enable cookies to allow the server to access the session
          xfbml: true, // parse social plugins on this page
          version: 'v2.8'
        });
      };
      insertScript(id, '//connect.facebook.net/en_US/sdk.js');

      const fbLogin = () => {
        window.FB.login(
          (response) => {
            const type = 'fb';
            if (response.authResponse) {
              const { userID: uid, accessToken: token } = response.authResponse;
              window.FB.api('/me', { fields: 'id,name,picture,gender' }, () => {
                that.loginFromOtherChannel(uid, token, type);
                setTimeout(() => {
                  window.FB.logout(() => {
                    console.log('fb 退出');
                  });
                }, 1000);
              });
            } else {
              console.log('User cancelled login or did not fully authorize.');
            }
          },
          { scope: 'public_profile, email' }
        );
      };

      // 第二次点击
      if (window.FB) {
        fbLogin();
      }

      document.getElementById(id).onload = () => {
        fbLogin();
      };
    },
    handleGGClick(e) {
      // 谷歌按钮在iframe里，在外层无法触发click事件。https://stackoverflow.com/questions/3690812/capture-click-on-div-surrounding-an-iframe
      console.log('handleGGClick');
      if (!this.isAgree) {
        console.log('no agree', e);
        this.showAgreeTips = true;
        e.stopImmediatePropagation();
        return;
      }
    },
    ggLoginCallNew(account) {
      console.log('ggLoginCallNew account', account);
      this.loginFromOtherChannel('', account.credential, 'gg');
    },
    ggLoginCall() {
      if (!this.isAgree) {
        this.showAgreeTips = true;
        return;
      }
      const that = this;
      const id = 'google-jssdk';

      insertScript(id, 'https://apis.google.com/js/api:client.js');

      const attachSignin = (element) => {
        window.auth2.attachClickHandler(
          element,
          {},
          (googleUser) => {
            console.log(googleUser);
            const type = 'gg';
            const token = googleUser.getAuthResponse().id_token;
            that.loginFromOtherChannel('', token, type);
            setTimeout(() => {
              window.gapi.auth2.getAuthInstance().signOut();
            }, 1000);
          },
          (err) => {
            console.log(err);
          }
        );
      };
      const startApp = () => {
        window.gapi.load('auth2', () => {
          window.auth2 = window.gapi.auth2.init({
            client_id:
              '322067568803-p11qbhovgr87s4n51en6n876b7q57l6k.apps.googleusercontent.com',
            cookiepolicy: window.location.host
          });
          attachSignin(document.getElementById('ggLoginBtn_e'));
        });
      };

      document.getElementById(id).onload = () => {
        startApp();
        setTimeout(() => {
          document.getElementById('ggLoginBtn_e').click();
        }, 1000);
      };
    },
    async twLoginCall() {
      if (!this.isAgree) {
        this.showAgreeTips = true;
        return;
      }
      const deviceId = await getDeviceId();
      const data = {
        interfaceName: 'twLogin',
        deviceId
      };
      const res = await this.$api.twLogin(data);
      if (res && res.code === 0) {
        window.location.href = res.data.redirect_url;
      }
    },
    vkLoginCall() {
      if (!this.isAgree) {
        this.showAgreeTips = true;
        return;
      }
      const that = this;
      const id = 'vk-jssdk';
      const vkApiIds = {
        'www.bigo.tv': 6773865,
        'bggray-www.bigo.tv': 7347724
      };

      insertScript(id, 'https://vk.com/js/api/openapi.js');

      const vkLogin = () => {
        window.VK.Auth.login((response) => {
          const type = 'vk';
          if (response.session) {
            const {
              user: { id: uid },
              sig: sign,
              expire,
              mid,
              secret,
              sid
            } = response.session;
            const token = `expire=${expire}mid=${mid}secret=${secret}sid=${sid}`;

            that.loginFromOtherChannel(uid, token, type, sign);

            window.VK.api(
              'users.get',
              { uids: uid, fields: 'photo_50' },
              () => {
                setTimeout(() => {
                  window.VK.Auth.logout();
                }, 500);
              }
            );
          }
        });
      };

      if (window.VK) {
        vkLogin();
      }

      document.getElementById(id).onload = () => {
        window.VK.init({
          apiId: vkApiIds[window.location.hostname]
        });
        vkLogin();
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.LoginPopup-Component {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.loading {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  background: rgba(238, 238, 238, 0.8);

  img {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 40px;
    height: 40px;
  }
}

.login-menu {
  .login-menu__title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: #2f3033;
    line-height: 28px;
    margin-top: 24px;
    margin-bottom: 28px;
    position: relative;
    z-index: 1;
  }

  .login-menu__before {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;

    .qrcode-box {
      position: relative;
      display: table;
      width: 164px;
      height: 164px;
      padding: 5px;
      border-radius: 5px;
      border: 1px solid #e1e3e6;

      .qrcode-loading {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 30px;
        height: 30px;

        img {
          width: 100%;
        }
      }

      .qrcode-image {
        position: relative;
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        z-index: 2;
      }

      .qrcode-overdue {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
        background: rgba(255, 255, 255, 0.95);

        .qrcode-overdue__tips {
          margin-top: 35px;
          font-size: 16px;
          color: #666666;
          text-align: center;
          line-height: 50px;
        }

        .qrcode-overdue__btn-refresh {
          display: block;
          width: 150px;
          height: 36px;
          margin: auto;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          border-radius: 36px;
          background: linear-gradient(90deg, #2ee6d6 0%, #00d2e5 100%);
          font-weight: 600;
          color: #ffffff;
          line-height: 14px;
        }
      }
    }

    .scan-tips {
      max-width: 164px;
      margin-top: 16px;
      font-size: 12px;
      font-weight: 400;
      color: #8a8f99;
      line-height: 14px;
      text-align: center;

      // &::before {
      //   content: '';
      //   float: left;
      //   display: block;
      //   width: 24px;
      //   height: 25px;
      //   margin-right: 18px;
      //   background: url(~@assets/img/icon.png) -82px -1080px no-repeat;
      // }
    }

    .scan-sample {
      width: 130px;
      height: 233px;
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('~@/assets/img/scan-sample.png');
      margin-left: 16px;
    }
  }

  .other-login {
    width: 300px;
    margin: 26px auto 0;
    text-align: center;
    border-top: 1px #e1e3e6 solid;

    .other-login__or {
      position: relative;
      top: -10px;
      padding: 0 10px;
      background: #fff;
      font-size: 12px;
      font-weight: 400;
      color: #c4c7cc;
      line-height: 12px;
    }

    .other-login__box {
      width: 100%;
      margin-top: 8px;
      margin-bottom: 15px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      button {
        display: inline-block;
        width: 41px;
        height: 41px;
        margin: 0 6px;
      }

      &__facebook {
        background-position: center center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url(~@assets/img/fb.png);
      }

      &__google {
        background: url(~@assets/img/icon2.png) -64px -335px no-repeat;
      }

      &__phone {
        background: url(~@assets/img/icon2.png) -3px -380px no-repeat;
      }

      &__vk {
        background-position: center center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url(~@assets/img/vk.png);
      }

      &__twitter {
        background: url(~@assets/img/icon2.png) -3px -425px no-repeat;
      }
    }
  }
}

.register-tips {
  font-size: 14px;
  font-weight: 500;
  color: #2f3033;
  line-height: 16px;

  a {
    color: #00ddcc;
    text-decoration: underline;
  }
}
</style>
